import React, { Component } from 'react';
import WidgetLoading from '../../../widget/WidgetLoading';
import NoData from '../../com/NoData';
import './jobType.scss';
class JobTypeTree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      total: 0,
      initialized: false,
      showPopup: false,
      popupContent: null,
      popupTimeout: null,
      currentHoverPath: null,
      isPopupHovered: false
    };
    this.popupRef = React.createRef();
    this.itemRefs = {};
  }

  componentDidMount() {
    this.initializePagination();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.initializePagination();
    }
  }

  componentWillUnmount() {
    if (this.state.popupTimeout) {
      clearTimeout(this.state.popupTimeout);
    }
  }

  initializePagination = () => {
    const { data } = this.props;
    if (data && data.length > 0) {
      this.setState({
        total: data.length,
        initialized: true
      });
    }
  }

  getTotalPages = () => {
    const { data } = this.props;
    const { records = 5 } = this.props?.options;
    return data && data.length > 0
      ? Math.ceil(data.length / records)
      : 0;
  }

  getCurrentPageData = () => {
    const { page } = this.state;
    const { data } = this.props;
    const { records = 5 } = this.props?.options;
    if (!data || data.length === 0) return [];
    const startIndex = (page - 1) * records;
    const endIndex = startIndex + records;
    return data.slice(startIndex, endIndex);
  }

  prevPage = () => {
    const { page } = this.state;
    const totalPages = this.getTotalPages();
    if (totalPages <= 0) return;
    if (page > 1) {
      this.setState({ page: page - 1 });
    } else {
      this.setState({ page: totalPages });
    }
  }

  nextPage = () => {
    const { page } = this.state;
    const totalPages = this.getTotalPages();
    if (totalPages <= 0) return;
    if (page < totalPages) {
      this.setState({ page: page + 1 });
    } else {
      this.setState({ page: 1 });
    }
  }



  handleMouseEnter = (content, path) => {
    if (this.state.popupTimeout) {
      clearTimeout(this.state.popupTimeout);
      this.setState({ popupTimeout: null });
    }

    this.setState({
      showPopup: true,
      popupContent: content,
      currentHoverPath: path
    });
  }

  handleMouseLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    const currentElement = e.currentTarget;

    // 新增：检查 relatedTarget 是否为有效节点
    if (!relatedTarget || !(relatedTarget instanceof Node)) {
      return;
    }

    // 新增：检查 currentElement 是否为有效节点
    if (!(currentElement instanceof Node)) {
      return;
    }

    // 新增：检查 popupRef 是否已挂载
    const popupElement = this.popupRef.current;
    const isPopupValid = popupElement instanceof Node;

    const isMovingToChild = relatedTarget && (
      currentElement.contains(relatedTarget) ||
      (isPopupValid && popupElement.contains(relatedTarget))
    );

    if (!isMovingToChild) {
      const popupTimeout = setTimeout(() => {
        if (!this.isMouseInRelatedArea()) {
          this.setState({
            showPopup: false,
            popupContent: null,
            currentHoverPath: null
          });
        }
      }, 300);

      this.setState({ popupTimeout });
    }
  }

  handlePopupMouseLeave = (e) => {
    const relatedTarget = e.relatedTarget;
    const popupElement = this.popupRef.current;

    // 新增：检查 relatedTarget 是否为有效节点
    if (!relatedTarget || !(relatedTarget instanceof Node)) {
      return;
    }

    // 新增：检查 popupElement 是否为有效节点
    if (!(popupElement instanceof Node)) {
      return;
    }

    // 优化：过滤无效节点
    const relatedItems = Array.from(
      document.querySelectorAll('.job-li-item, .child-item-wrapper')
    ).filter(el => el instanceof Node);

    const isMovingToRelatedItem =
      popupElement.contains(relatedTarget) ||
      relatedItems.some(el => el.contains(relatedTarget));

    if (!isMovingToRelatedItem) {
      const popupTimeout = setTimeout(() => {
        this.setState({
          showPopup: false,
          popupContent: null,
          currentHoverPath: null,
          isPopupHovered: false
        });
      }, 300);

      this.setState({ popupTimeout });
    }
  }

  isMouseInRelatedArea = () => {
    const { isPopupHovered } = this.state;
    return isPopupHovered;
  }

  handlePopupMouseEnter = () => {
    if (this.state.popupTimeout) {
      clearTimeout(this.state.popupTimeout);
    }
    this.setState({
      isPopupHovered: true,
      popupTimeout: null
    });
  }

  handlePopupMouseLeave = (e) => {
    const relatedTarget = e.relatedTarget;

    // 最基本的检查：确保有目标元素且是Node类型
    if (!relatedTarget || !(relatedTarget instanceof Node)) {
      // console.log('[Popup] Invalid relatedTarget:', relatedTarget);
      return;
    }

    // 获取并验证popup元素
    const popupElement = this.popupRef.current;
    if (!popupElement || !(popupElement instanceof Node)) {
      console.log('[Popup] Invalid popupElement:', popupElement);
      return;
    }

    // 使用try-catch包裹contains调用，防止意外错误
    let isInPopup = false;
    try {
      isInPopup = popupElement.contains(relatedTarget);
    } catch (error) {
      console.error('[Popup] Error checking popup containment:', error);
      isInPopup = false;
    }

    // 获取并验证相关项列表
    let isInRelatedItem = false;
    try {
      const relatedItems = Array.from(
        document.querySelectorAll('.job-li-item, .child-item-wrapper')
      ).filter(el => el instanceof Node && document.body.contains(el));

      isInRelatedItem = relatedItems.some(el => {
        try {
          return el.contains(relatedTarget);
        } catch (error) {
          console.error('[Popup] Error checking related item containment:', error);
          return false;
        }
      });
    } catch (error) {
      console.error('[Popup] Error querying related items:', error);
      isInRelatedItem = false;
    }

    const isMovingToRelatedItem = isInPopup || isInRelatedItem;

    if (!isMovingToRelatedItem) {
      const popupTimeout = setTimeout(() => {
        this.setState({
          showPopup: false,
          popupContent: null,
          currentHoverPath: null,
          isPopupHovered: false
        });
      }, 300);

      this.setState({ popupTimeout });
    }
  };


  onTypeChange = (data) => {
    this.props.history.push({ pathname: '/home/recommendedJob', state: { JOBTYPE: data?.code } });
  }

  render() {
    const { page } = this.state;
    const currentPageData = this.getCurrentPageData();
    const totalPages = this.getTotalPages();
    const { loading } = this.props;

    return (
      <WidgetLoading loading={loading}>
        <div component-data='jobTypet'>
          <div className='jobTypet_Tree'>
            <div className='jobTypet_box' onMouseLeave={this.handleMouseLeave}>
              {currentPageData && currentPageData.length > 0 ? (
                currentPageData.map((item) => (
                  <div
                    key={item.code}
                    className='job-li-item'
                    ref={(el) => this.itemRefs[item.code] = el}
                    onMouseEnter={() => this.handleMouseEnter(item, item.code)}
                  >
                    <div className='job-li-items'>
                      <div className='typeTitle'>{item.name}</div>
                      {item.children.slice(0, 3).map((children) => (
                        <a className='job-li-item_a'>{children.name}</a>
                      ))}
                      <img
                        className='iboss'
                        src={require("../../../img/pinzhunzhun/dataSource/iboss.svg")}
                        alt="iboss"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <NoData width={'230px'} height={'230px'} />
              )}
              {this.state.showPopup && (
                <div
                  className="custom-popup"
                  ref={this.popupRef}
                  onMouseEnter={this.handlePopupMouseEnter}
                  onMouseLeave={this.handlePopupMouseLeave}
                >
                  <p className='title'>
                    {this.state.popupContent?.name}
                  </p>

                  <ul>
                    {
                      this.state.popupContent && this.state.popupContent.children.map((child) => (
                        <li>
                          <h4>{child.name}</h4>
                          <div className='text'>
                            {child && (child?.children || []).map((i) => (
                              <a
                                key={i.code}
                                className='job-li-item_a'
                                onClick={() => { this.onTypeChange(i) }}
                                onMouseEnter={() => this.handleMouseEnter(this.state.popupContent, `${this.state.popupContent.code}/${i.code}`)}
                              >
                                {i.name}
                              </a>
                            ))}
                          </div>
                        </li>
                      ))
                    }
                  </ul>
                </div>
              )}
            </div>
            {totalPages > 1 && (
              <div className="job-menu-page sf-page-tool-between">
                <div className="menu-page-info">
                  {page} / {totalPages}
                </div>
                <div className='btn_page'>
                  <img
                    src={require("../../../img/pinzhunzhun/dataSource/prevPage.svg")}
                    onClick={this.prevPage}
                    alt="上一页"
                  />
                  <img
                    style={{ marginLeft: "12px" }}
                    src={require("../../../img/pinzhunzhun/dataSource/nextPage.svg")}
                    onClick={this.nextPage}
                    alt="下一页"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </WidgetLoading>
    );
  }
}

export default JobTypeTree;